import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { INotificationHandler } from '../../../../../core/services/utils/notification-handler.service';

interface IPageAc2002 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}  
/* @ngInject */
export default function Ac2002Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemForage: IMenuItemForageClass,
    MenuItemAction: IMenuItemActionClass,
    notificationHandler: INotificationHandler,
    $state: IStateService,
    $stateParams: IStateParamsService,
    ac0010Route: IRoute,
    cp0005Route: IRoute,
    ac0005Route: IRoute
) {

    const vm: IPageAc2002 = this;
    /**
     * CRÉATION DOCUEMENT D'ACHAT 
     * VIA ENTITÉ EXTERNE
     */
    const docAchatRef = new MenuItemAction(
        'LBL_DOC_REF',
        'BOU_MSG',
        (rowData: any) => ({
            refcleint: rowData.refcleint,
            intcleintreq: rowData.intcleintreq,
            etrcleintref: rowData.etrcleint,
            type: $stateParams.type
        }),
        {
            fonction: 'BTNDOCACHREF',
            icon: 'add_circle',
            iconButton: true,
            successAction: (response) => {
                response.response && 
                 notificationHandler.info({
                            lblMessage: response.response
                        });
                        /**
                         * forage vers ac0010
                         */
                $state.go(ac0010Route.NAME, {
                    refcleint: response.refcleint,
                    intcleintreq: response.intcleintreq,
                    etrcleintref: response.etrcleintref,
                    type: response.type,
                    menuId: $state.params.menuId,
                    typeCreation: 'ref'
                });
            }
        }
    );
    //CP0005
    const DOcfournis = new MenuItemForage(
        '',
        cp0005Route.NAME,
        (rowData: any) => ({
            id: rowData.foucleint,
            refcleint: rowData.refcleint
        }),
        {
            fonction: 'BTNDOCFOUR',
            iconButton: true
        }
    );
    /**
     * CRÉATION DOCUEMENT D'ACHAT 
     * VIA L'ENTENTE CONTRACTUELLE
     */
    const docAchatEtr = new MenuItemAction(
        'LBL_DOC_ENT',
        'BOU_MSG_ENT',
        (rowData: any) => ({
            refcleint: rowData.refcleint,
            intcleintreq: rowData.intcleintreq,
            etrcleintref: rowData.etrcleint,
            radcleint : rowData.radcleint
        }),
        {
            fonction: 'BTNDOCACHETR',
            icon: 'add_circle',
            iconButton: true,
            successAction: (response) => {
                response.response && 
                 notificationHandler.info({
                     lblMessage: response.response
                  });
               response.avertssement && 
               notificationHandler.avertissement({
                            lblMessage: response.avertssement
                        });
                $state.go(ac0010Route.NAME, {
                   refcleint: response.refcleint,
                    intcleintreq: response.intcleintreq,
                    etrcleint: response.etrcleintref, 
                    menuId: $state.params.menuId
                });
            },
             hidden: (rowData: any) => (!rowData.etrcleint)  
        }
    );

    // AC0005 
    const docEntContr = new MenuItemForage(
        'LBL_DER',
        ac0005Route.NAME,
        (rowData: any) => ({ id: rowData.etccleint }),
        {
            icon: 'exit_to_app',
            fonction: 'BTNDOCENTCONT',
            hidden: (rowData: any) => !rowData.etccleint  
        },
    ); 

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true,
            suiviModification: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('intcleintreqcri', {
                required: true,
                largeur: 50
            }),
            new FormulaireItem('refcleintcri', { largeur: 50 }),
            new FormulaireItem('caacleintcri', { largeur: 50 }),
            new FormulaireItem('tfocleintcri', { largeur: 50 })
        ]),
        colonnesVisibles: [
            { nom: 'refcod', largeur: 190, menu: [docAchatRef, DOcfournis] },
            { nom: 'refnom', largeur: 200 },
            { nom: 'etcnumdoc', largeur: 250, menu: [docAchatEtr, docEntContr]  },
            { nom: 'etcdsc', largeur: 200 },
            { nom: 'etcflgitm', largeur: 100},
            { nom: 'caacod', largeur: 100 },
            { nom: 'caadsc', largeur: 200 }
        ],
        colonnesCachees: [
            'refcleint',
            'etrcleint',
            'caacleint',
            'intcleintreq',
            'foucleint',
            'etccleint'
        ]
    };
}